import type { HTMLAttributes } from 'react';

export interface InputCheckboxFieldData {
  disabled?: boolean;
}

export interface InputCheckboxFieldProps
  extends HTMLAttributes<HTMLInputElement>,
    InputCheckboxFieldData {
  name: string;
}
